import * as config from '../wips.config.js';

let orte: any[] = [];

export async function initOrte() {
    orte = await loadOrte();
}

export function getBundesland(plz: string): string {
    const bundesland =  ((orte || []).find((item: any) => (item.plz || null) === plz) || {}).bundesland || null;
    // alert(plz + ' -> ' + bundesland);
    return bundesland;
}

export function getOrt(plz: string): string {
    return ((orte || []).find((item: any) => (item.plz || null) === plz) || {}).ort || null;
}


async function loadOrte() {
  const res = await fetch(config.orte_file ? config.orte_file : 'orte.json');
  const data = await res.json();
  return data;
}